<script>
    import {elementDetails} from '../workspacesStore.js';
    import DataTable from '../../DataGrid/DataTable.svelte';
    import HazardControlColumn from './HazardControlColumn.svelte';
    import {sgettext} from '../../../i18n.js';

    export let rows = $elementDetails ? $elementDetails.hazardscontrols : [];
    let tableId="hazardControlTableId"
    
    let columns = {
        global_hazard: {
            label: sgettext('$$RISK$$'),
            renderer: HazardControlColumn,
            width: '50%'
        },
        global_control: {
            label: sgettext('$$CONTROL$$'),
            renderer: HazardControlColumn,
            width: '50%',
            field:'control'
        }
    }
</script>


<DataTable
    small={true}
    {columns}
    {rows}
    {tableId}
    field={"hazard"}
/>
